import { action } from "satcheljs/lib/legacy";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

/**
 * THIS IS NOT USED ANYMORE under the NewAddGroupExperience Feature flag. Once that FF is in PROD, this can be deleted.
 * Sets the visiblity of the hover column in the schedules view state
 */
export let setHoverColumnHidden = action("setHoverColumnHidden")(
    function setHoverColumnHidden(viewState: SchedulesViewStateStore, isHidden: boolean) {
        viewState.isHoverColumnHidden = isHidden;
    }
);